export const LISTA_COMPRAS_CREATE = "LISTA_COMPRAS_CREATE";
// export const LISTA_COMPRAS_UPDATE = 'LISTA_COMPRAS_UPDATE'
export const LISTA_COMPRAS_LOAD = "LISTA_COMPRAS_LOAD";
export const LISTA_COMPRAS_REMOVE = "LISTA_COMPRAS_REMOVE";
